import type { RouteRecordRaw } from 'vue-router'

const portfolioRoutes: RouteRecordRaw[] = [
  {
    path: 'portfolio',
    component: () => import('@/views/portfolio/PortfolioLayout.vue'),
    redirect: '/portfolio/alignments',
    meta: { permission: 'project:alignment:view' },
    children: [
      {
        path: 'alignments',
        name: 'portfolio-alignments',
        component: () => import('@/views/portfolio/AlignmentList.vue'),
        meta: { permission: 'project:alignment:view' }
      },
      {
        path: 'alignments/:id',
        name: 'portfolio-alignment-detail',
        component: () => import('@/views/portfolio/AlignmentDetail.vue'),
        meta: { permission: 'project:alignment:view' }
      }
    ]
  }
]

export default portfolioRoutes
